import EtablissementLicenceSpectacle from '@/generated/controls/etablissement/EtablissementLicenceSpectacle.vue';
import {defineComponent} from "vue";

export default defineComponent({
    components: {},
    extends: EtablissementLicenceSpectacle
})
